module.exports = __webpack_public_path__ + "img/guide-install.3c6aa24f.png";